module.exports = __webpack_public_path__ + "img/16.be2969d7.jpg";